export const NO_RESULTS = 'Aucun résultat trouvé';
export const LBL_SEARCH = 'Recherche';
